export type _antifraudAccess = 'action' | 'view' | 'none'

const ACTION_AREAS = ['juridico', 'comercial']

const VIEW_ONLY_AREAS = ['credito', 'engenharia']

const AREA_LEVELS = ['administrator', 'backoffice']

const CANCELED_PROPOSAL_STATUS = 'canceled'

const DELIBERATED_STEP_STATUS = ['approved', 'reproved']

// O Suporte Comercial é um nível próprio (commercial), fora do administrator/backoffice por área
const ACTION_LEVELS = ['master', 'commercial']

export function antifraudAccess (level?: string, areaName?: string): _antifraudAccess {
  if (level && ACTION_LEVELS.includes(level)) return 'action'
  if (level === 'auditor') return 'view'
  if (!level || !AREA_LEVELS.includes(level)) return 'none'
  if (areaName && ACTION_AREAS.includes(areaName)) return 'action'
  if (areaName && VIEW_ONLY_AREAS.includes(areaName)) return 'view'

  return 'none'
}

export function canActOnAntifraud (level?: string, areaName?: string): boolean {
  return antifraudAccess(level, areaName) === 'action'
}

export function acertPixResendAfterUnicoAllowed (proposalStatus?: string): boolean {
  return proposalStatus !== CANCELED_PROPOSAL_STATUS
}

// O EmailAge tem um botão só no topo; o AcertPix depois do Único vale mesmo com o passo deliberado
export function processResendEnabled (
  process: { canResend?: boolean, resendKey?: string, resendAfterUnico?: boolean },
  options: { actionsEnabled: boolean, afterUnicoResendEnabled: boolean }
): boolean {
  if (!process.canResend || process.resendKey === 'emailAge') return false

  return options.actionsEnabled || (Boolean(process.resendAfterUnico) && options.afterUnicoResendEnabled)
}

export function resendIsBlocked (
  stepStatus?: string,
  proposalStatus?: string,
  options: { allowAutomaticReproval?: boolean, automaticDecision?: boolean } = {}
): boolean {
  if (proposalStatus === CANCELED_PROPOSAL_STATUS) return true

  if (options.allowAutomaticReproval && stepStatus === 'reproved' && options.automaticDecision) {
    return false
  }

  return Boolean(stepStatus) && DELIBERATED_STEP_STATUS.includes(String(stepStatus))
}
